require("dotenv").config();
import axios from "axios";

const apiURL = `${process.env.VUE_APP_TRANSLATIONS_APP_API_URL}/admin/company`;

class CompanyService {
  // Get company
  static GetCompany(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios.post(`${apiURL}/get`, data).then(
              (response) => {
                return response.data;
              },
              (error) => {
                return error.response.data;
              }
            );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })()
      );
    });
  }

  // Update settings
  static UpdateSettings(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios.post(`${apiURL}/settings/update`, data).then(
              (response) => {
                return response.data;
              },
              (error) => {
                return error.response.data;
              }
            );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })()
      );
    });
  }

  // Get subscription details from Chargebee
  static GetChargebeeSubscription(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios
              .post(`${apiURL}/subscription/get-chargebee`, data)
              .then(
                (response) => {
                  return response.data;
                },
                (error) => {
                  return error.response.data;
                }
              );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })()
      );
    });
  }

  // Update licenses for the app
  static UpdateLicenses(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios
              .post(`${apiURL}/subscription/update-licenses`, data)
              .then(
                (response) => {
                  return response.data;
                },
                (error) => {
                  return error.response.data;
                }
              );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })()
      );
    });
  }

  // Mark the quick start guide as completed
  static MarkGuideCompleted(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios.post(`${apiURL}/quickstart/complete`, data).then(
              (response) => {
                return response.data;
              },
              (error) => {
                return error.response.data;
              }
            );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })()
      );
    });
  }
}

export default CompanyService;
